import React, { useEffect, useState } from "react";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import { Col, Row, Container } from "react-bootstrap";
import "./documentpdfmodal.scss";
import { bindActionCreators } from "redux";
import LoadingSpinner from "../../atoms/Loader";
import { useSelector, useDispatch } from "react-redux";
import { ErrorMessages } from "../../atoms/ErrorMessages";
import { RESET_GET_DOCUMENT_ERROR } from "../../redux/actions/types";
import { actionCreators } from "../../redux/actions";
import LabelText from "../../atoms/LabelText";
import { popupBlockerText } from "../../constants/constants";

const DocumentPdfModal = (props) => {
  const dispatch = useDispatch();
  const { getDocumentContent } = bindActionCreators(
    actionCreators,
    dispatch, // eslint-disable-line
  );
  const { getDocumentFetching, getDocumentData, getDocumentError } =
    useSelector((state) => state.documentReducer);
  const { onHide } = props;

  const [btnSelection, setBtnSelection] = useState("");
  const [isError, setIsError] = useState(false);
  const [errMessage, setErrMessage] = useState("Please try again later.");

  useEffect(() => {
    if (getDocumentData && getDocumentData["documentData"]) {
      if (getDocumentData?.documentData.docContent) {
        if (btnSelection === "handlePdfPreview")
          openPdfPreview(getDocumentData?.documentData.docContent);
        else {
          downloadPdfFile(getDocumentData?.documentData.docContent);
        }
      }
    }
  }, [getDocumentData?.documentData]);

  useEffect(() => {
    if (getDocumentError) {
      setErrMessage(
        "Not able to connect to server. Please try after some time.", // eslint-disable-line
      );
    }
  }, [getDocumentError]);

  const resetErrStates = () => {
    setIsError(false);
    setErrMessage("");
    dispatch({ type: RESET_GET_DOCUMENT_ERROR });
  };
  const handlePdfPreview = async () => {
    resetErrStates();
    setBtnSelection("handlePdfPreview");
    if (
      getDocumentData["documentData"] == null ||
      Object.keys(getDocumentData?.documentData).length == 0
    ) {
      getDocumentContent(props.investorId, props.selectedDocIndex);
    } else {
      openPdfPreview(getDocumentData?.documentData?.docContent);
    }
  };

  const handleDownloadPdf = () => {
    resetErrStates();
    setBtnSelection("downloadPdfFile");
    if (
      getDocumentData["documentData"] == null ||
      Object.keys(getDocumentData?.documentData).length == 0
    ) {
      getDocumentContent(props.investorId, props.selectedDocIndex);
    } else {
      downloadPdfFile();
    }
  };
  function downloadPdfFile() {
    makeReadApiCall();
    const fileName = `${getDocumentData?.documentData?.documentName}.pdf`;
    const base64Data = getDocumentData?.documentData?.docContent;

    const isIOS =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    // Convert base64 to Blob
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "application/pdf" });
    const blobUrl = URL.createObjectURL(blob);

    if (isIOS) {
      // Open in new tab for iOS
      const newTab = window.open(blobUrl, "_blank");
      if (!newTab) {
        setIsError(true);
        setErrMessage("Popup blocked. Please allow popups and try again.");
      }
    } else {
      // Trigger download for other platforms
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  }

  async function openPdfPreview(mDocContent) {
    try {
      const url = "data:application/pdf;base64," + mDocContent;
      const blob = await fetch(url).then((res) => res.blob());
      const blobUrl = URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = blobUrl;
      a.target = "_blank";
      a.click();
    } catch (error) {
      console.error("Error getting doc preview", error);
      setIsError(true);
      setErrMessage("Unable to load file content. Please click Preview again.");
    }
    makeReadApiCall();
  }

  const makeReadApiCall = () => {
    if (!props.selectedDocIsRead && props.selectedDocIndex) {
      props.makeApiToInsertDocStatus(props.investorId, props.selectedDocIndex);
    }

    //onHide(); TODO: Uncomment if wants to hide the dialog.
  };
  return (
    <>
      <Container fluid className="documentpdf-modal">
        <Row>
          <Col className="text-end">
            <Icons
              iconname="close-large"
              variant="icon-sixteen-px"
              clickHandler={onHide}
            />
          </Col>
        </Row>
        <div className="dialog-content">
          <Row>
            <Col className="heading mt-2 mb-1">
              <div>Your document is ready for Preview and Download</div>
            </Col>
          </Row>
          <Row className="mt-2 download-print-preview-container">
            <Col>
              <Buttons
                handleClick={() => handlePdfPreview()}
                className="btn btn-secondary"
                name="Preview"
              />
            </Col>
            <Col className="download-print-btn-container">
              <Buttons
                handleClick={() => handleDownloadPdf()}
                className="primary"
                name="Download & Print"
              />
            </Col>
          </Row>
          <LabelText section="documents" text={popupBlockerText} />
          {(getDocumentError || isError) && (
            <Row className="doc-error ms-2 me-2 mt-3">
              <ErrorMessages
                // text="Unable to load file content. Please click Preview again."
                text={errMessage}
                className="alert-message text-center"
              />
            </Row>
          )}
          {getDocumentFetching && (
            <Row className="loader-docs">
              <LoadingSpinner />
            </Row>
          )}
        </div>
      </Container>
    </>
  );
};

export default DocumentPdfModal;
